
import 'swiper/css/swiper.min.css'
import Swiper from 'swiper'
export default {
  name: 'ImageGallerySlice',
  props: ['slice'],
  data() {
    return {
      swiper: null,
      id: this.slice.id
    }
  },
  mounted() {
    const self = this
    this.swiper = new Swiper(`#${this.id}`, {
      observer: true,
      observeSlideChildren: true,
      observeParents: true,
      slidesPerView: 1.2,
      direction: 'horizontal',
      // centeredSlides: true,
      spaceBetween: 20,
      mousewheel: {
        forceToAxis: true,
        invert: false,
      },
      freeMode: true,
      // pagination: {
      //   el: '.swiper-pagination',
      //   type: 'progressbar',
      //   clickable: true,
      // },
      breakpoints: {
        1280: {
          slidesPerView: 'auto',
        },
        1024: {
          slidesPerView: 'auto',
        },
        768: {
          slidesPerView: 2,
        },
        480: {
          slidesPerView: 1,
        },
      },
      navigation: {
        nextEl: `#${this.id}-navigation-next`,
        prevEl: `#${this.id}-navigation-prev`
      },
    })
  },
}
